// Local Web Audio synthesis: no external audio files or network dependency.
export function createOutageSiren() {
    let context = null;
    let active = null;
    const stop = () => {
        if (!active) return;
        const tone = active;
        active = null;
        tone.oscillator.onended = null;
        try { tone.oscillator.stop(); } catch (_) { /* already stopped */ }
        tone.oscillator.disconnect();
        tone.gain.disconnect();
    };
    return {
        async enable() {
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            if (!AudioContext) throw new Error('Este navegador não suporta o alerta sonoro.');
            if (!context || context.state === 'closed') context = new AudioContext();
            await context.resume();
            if (context.state !== 'running') throw new Error('O navegador bloqueou o áudio. Clique novamente para ativar a sirene.');
        },
        play() {
            if (!context || context.state !== 'running') return false;
            stop();
            const oscillator = context.createOscillator();
            const gain = context.createGain();
            const start = context.currentTime;
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(500, start);
            for (let i = 1; i <= 8; i++) oscillator.frequency.linearRampToValueAtTime(i % 2 ? 1100 : 500, start + i * 0.75);
            gain.gain.setValueAtTime(0, start);
            gain.gain.linearRampToValueAtTime(0.12, start + 0.1);
            gain.gain.setValueAtTime(0.12, start + 5.8);
            gain.gain.linearRampToValueAtTime(0, start + 6);
            oscillator.connect(gain);
            gain.connect(context.destination);
            active = { oscillator, gain };
            oscillator.onended = () => {
                oscillator.disconnect(); gain.disconnect();
                if (active?.oscillator === oscillator) active = null;
            };
            oscillator.start(start);
            oscillator.stop(start + 6);
            return true;
        },
        stop,
        dispose() {
            stop();
            const previous = context;
            context = null;
            if (previous && previous.state !== 'closed') previous.close().catch(() => {});
        },
    };
}

export function createOutageArrivalTracker() {
    let initialized = false;
    const seen = new Set();
    return (events, fromCache = false) => {
        // Establish the baseline from the server; opening the page is not a new incident.
        if (fromCache) return false;
        const arrived = initialized && events.some(event => event.status === 'suspected' && !seen.has(event.id));
        events.forEach(event => seen.add(event.id));
        initialized = true;
        return arrived;
    };
}
